import { render } from "./legalWarning.vue?vue&type=template&id=345b74db&scoped=true&lang=html"
import script from "./legalWarning.vue?vue&type=script&lang=js"
export * from "./legalWarning.vue?vue&type=script&lang=js"

import "./legalWarning.vue?vue&type=style&index=0&id=345b74db&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345b74db"]])

export default __exports__